import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { RiSurveyFill } from 'react-icons/ri';

const SurveyButtonWrapper = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: #1b8a8c;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(27, 138, 140, 0.2);

  &:hover {
    background: #15696b;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(27, 138, 140, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(27, 138, 140, 0.2);
  }

  &.active {
    background: #0f4d4f;
    box-shadow: 0 4px 12px rgba(27, 138, 140, 0.4);
  }

  svg {
    font-size: 1.25rem;
  }

  @media (max-width: 768px) {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;

    svg {
      font-size: 1.1rem;
    }
  }
`;

const SurveyButton = () => {
  return (
    <SurveyButtonWrapper to='/survey'>
      <RiSurveyFill />
      <span>סקר ארגוני</span>
    </SurveyButtonWrapper>
  );
};

export default SurveyButton;
